module.exports = __webpack_public_path__ + "static/img/24.6544fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/24.jpg
// module id = mqfx
// module chunks = 0